<h1 mat-dialog-title>Gebruikers van verwijderde organisatie verwijderen</h1>

<div mat-dialog-content class="dialog-content">
  @if (loading()) {
    <div class="loading"><mat-spinner diameter="32"></mat-spinner></div>
  } @else if (result(); as cleanupResult) {
    <p>
      {{ cleanupResult.updatedUserCount }} gebruikers aangepast en {{ cleanupResult.deletedUserCount }} gebruikers
      volledig verwijderd.
    </p>
    @if (cleanupResult.warningCount > 0 || cleanupResult.errorCount > 0) {
      <p class="result-warning">
        {{ cleanupResult.warningCount }} waarschuwingen en {{ cleanupResult.errorCount }} fouten.
      </p>
    }
    @if (cleanupResult.auditLogWarning) {
      <p class="result-warning">{{ cleanupResult.auditLogWarning }}</p>
    }
    <ul class="user-list" aria-label="Verwerkingsresultaten">
      @for (outcome of cleanupResult.outcomes; track outcome.uid) {
        <li>
          {{ outcome.email ?? outcome.uid }}: {{ outcome.action }}
          @if (outcome.error) {
            ({{ outcome.error }})
          }
        </li>
      }
    </ul>
  } @else if (loadFailed()) {
    <p>De verweesde organisaties konden niet worden opgehaald:</p>
  } @else if (orphanedOrganisationIds().length === 0) {
    <p>Er zijn geen gebruikers gekoppeld aan een verwijderde organisatie.</p>
  } @else {
    <mat-form-field>
      <mat-label>Verwijderde organisatie</mat-label>
      <mat-select [value]="selectedOrganisationId()" (valueChange)="selectOrganisation($event)">
        @for (organisationId of orphanedOrganisationIds(); track organisationId) {
          <mat-option [value]="organisationId">{{ organisationId }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (selectedOrganisationId()) {
      <p>{{ previewUsers().length }} betrokken gebruikers:</p>
      <ul class="user-list" aria-label="Betrokken gebruikers">
        @for (user of previewUsers(); track user.uid) {
          <li>{{ user.email ?? user.uid }}</li>
        }
      </ul>
      <p class="result-warning">Deze actie kan niet ongedaan worden gemaakt.</p>
    }
  }

  @if (error()) {
    <p class="error">{{ error() }}</p>
  }
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">{{ result() ? 'Sluiten' : 'Annuleren' }}</button>
  @if (!result()) {
    <button
      mat-flat-button
      class="error-color"
      type="button"
      [class.spinner]="processing()"
      [disabled]="!selectedOrganisationId() || processing()"
      (click)="cleanUsers()"
    >
      Verwijderen
    </button>
  }
</div>
